export const AppConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  baseURL2: process.env.REACT_APP_API_URL_2,
  baseURL3: process.env.REACT_APP_API_URL_3,
  baseURL4: process.env.REACT_APP_API_URL_4,
  echoServerURL: '',
  env: process.env.REACT_APP_ENV,
  awsImageURL: '',
  appTitle: 'Lawft',
  appVersion: '[Version 1]',
  presignedUrlHeaderKey: 'lawft_public_GabNGt0PXEAka97uoD5yvnK9RJ0y8CJr',
};
